import { render, staticRenderFns } from "./Fast.vue?vue&type=template&id=06867dd3&"
import script from "./Fast.vue?vue&type=script&lang=js&"
export * from "./Fast.vue?vue&type=script&lang=js&"
import style0 from "./Fast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports